import { Suspense } from "react";
import Box from "@mui/material/Box";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../../app/providers/AuthProvider";
import RouteFallback from "../../app/routing/RouteFallback";
import TopProgressBar from "../../shared/components/common/ui/TopProgressBar";
import { AppNavbar, MainContent, SideMenu } from "./components";
import { useSidebarDarkMode } from "./components/sidebar/sidebarColorMode";

export default function PrivateLayout() {
  const { isAuthenticated, status, user } = useAuth();
  const location = useLocation();
  const sidebarDark = useSidebarDarkMode();
  const backgroundColor = sidebarDark ? "#F4FAFA" : "#FAFBFC";

  const isEmailVerified = String(user?.emailVerified).toLowerCase() === "true";

  if (status === "booting") return null;
  if (!isAuthenticated) return null;

  if (!isEmailVerified && location.pathname !== "/verificar-email") {
    return <Navigate to="/verificar-email" replace />;
  }

  if (isEmailVerified && location.pathname === "/verificar-email") {
    return <Navigate to="/painel" replace />;
  }

  return (
    <Box
      sx={{
        backgroundColor,
        display: "flex",
        minHeight: "100vh",
        width: "100%",
      }}
    >
      <TopProgressBar />
      <AppNavbar />
      <SideMenu />
      <MainContent>
        {/* Boundary local: se uma página lazy suspender, só a área de
            conteúdo mostra o fallback — navbar e sidebar ficam visíveis. */}
        <Suspense fallback={<RouteFallback />}>
          <Outlet />
        </Suspense>
      </MainContent>
    </Box>
  );
}
